import { useState } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  Row,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import { CiEdit, CiFilter, CiTrash } from "react-icons/ci";
import { FaCheckCircle, FaRegEdit, FaTimesCircle } from "react-icons/fa";
import { IoAddCircleOutline } from "react-icons/io5";
import { TbError404, TbListDetails } from "react-icons/tb";
import "react-datepicker/dist/react-datepicker.css";
import { BiSearch } from "react-icons/bi";
import { RiResetLeftFill } from "react-icons/ri";
import Swal from "sweetalert2";

const BannerTable = ({
  banner,
  meta,
  fetchBanner,
  onEdit,
  onDelete,
  updateOnActive,
  loading
}) => {
  const handlePageChange = (page) => {
    fetchBanner(page, meta.itemsPerPage);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    fetchBanner(page, newPerPage);
  };
  const [selectedRows, setSelectedRows] = useState(false);
  const [toggledClearRows, setToggleClearRows] = useState(false);

  const handleChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };

  // Toggle the state so React Data Table changes to clearSelectedRows are triggered
  const handleClearRows = () => {
    setToggleClearRows(!toggledClearRows);
  };

  const handleToggleStatus = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to change status to ${row.active === 1 ? "Inactive" : "Active"}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const updatedStatus = row.active == 1 ? 0 : 1;
          
          updateOnActive(row.id, { id: row.id, active: updatedStatus });
          Swal.fire("Updated!", "Status has been updated.", "success");
        } catch (error) {
          console.error("Failed to update status", error);
          Swal.fire("Error!", "Failed to update status.", "error");
        }
      }
    });
  };

  const columns = [
    {
      name: "No.", // Serial Number Column
      selector: (row, index) => index + 1,
      sortable: true,
      width: "60px", // Optional: Adjusts the width
    },
    { name: "Text", selector: (row) => row.text, sortable: true },
    { name: "Tittle", selector: (row) => row.title, sortable: true },
    { name: "Type Banner", selector: (row) => row.typeBanner, sortable: true },
    {
      name: "Banner Image",
      selector: (row) =>
        row.banner ? (
          <>
            <img
              src={row.banner} // Replace with your image field
              // alt={row.name} // Add an alt attribute for accessibility
              style={{
                width: "30px",
                height: "30px",
                objectFit: "cover",
                borderRadius: "4px",
              }} // Styling
            />
          </>
        ) : (
          <TbError404 size={25} />
        ),
    },
    {
      name: "Active",
      cell: (row) => (
        <span
          style={{
            cursor: "pointer",
            color: row.active === 1 ? "green" : "red",
          }}
          onClick={() => handleToggleStatus(row)}
        >
          {row.active === 1 ? <FaCheckCircle /> : <FaTimesCircle />}{" "}
          {row.active === 1 ? "Active" : "Inactive"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ display: "flex", justifyContent: "center", gap: "5px" }}>
          <Button
            variant="outline-warning"
            size="sm"
            onClick={() => onEdit(row)}
          >
            <CiEdit size={16} />
          </Button>
          <Button
            variant="outline-danger"
            size="sm"
            onClick={() => onDelete(row)}
          >
            <CiTrash size={16} />
          </Button>
        </div>
      ),
      center: true, // Ensures alignment within DataTable
      width: "150px", // Adjust width if needed
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontSize: "14px", // Adjust header font size
        fontWeight: "bold",
      },
    },
    cells: {
      style: {
        fontSize: "12px", // Adjust cell font size
        padding: "0px",
        margin: "0px",
      },
    },
    rows: {
      style: {
        minHeight: "35px", // Minimum row height
        maxHeight: "35px", // Maximum row height (optional)
      },
    },
  };

  return (
    <>
      {selectedRows.length > 0 && (
        <button onClick={handleClearRows}>Clear Selected Rows</button>
      )}
      <Card>
        <Card.Body>
          <DataTable
            title="Banner"
            columns={columns}
            data={banner}
            progressPending={loading}
            pagination
            paginationServer // 🔥 WAJIB
            paginationTotalRows={meta.totalItems || 0}
            paginationPerPage={meta.itemsPerPage || 10}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
            responsive
            highlightOnHover
            customStyles={customStyles}
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default BannerTable;
